import { Observable } from "rxjs";
import {ApiHelperService} from "@services/apihelper/api-helper.service";
import {ErrorConfig} from "@models/error-config";

export abstract class CommonService<E, ID> {

  protected abstract API_URL: string;

  protected constructor(protected http: ApiHelperService) { }

  getAll(errorConfig?: ErrorConfig): Observable<E[]> {
    return this.http.get<E[]>(this.API_URL, errorConfig);
  }

  getOne(id: ID, errorConfig?: ErrorConfig): Observable<E> {
    return this.http.get<E>(`${this.API_URL}/${id}`, errorConfig);
  }

  save(entity: E, errorConfig?: ErrorConfig): Observable<E> {
    return this.http.post<E>(this.API_URL, entity, errorConfig);
  }

  update(entity: E, id: ID, errorConfig?: ErrorConfig): Observable<E> {
    return this.http.put<E, E>(`${this.API_URL}/${id}`, entity, errorConfig);
  }

  delete(id: ID, errorConfig?: ErrorConfig): Observable<E> {
    return this.http.delete<E>(`${this.API_URL}/${id}`, errorConfig);
  }

}
